export default __webpack_public_path__ + "static/media/320C.3502037a.jpg";